// extracted by mini-css-extract-plugin
export var buttons = "styles-module--buttons--5c2d0";
export var exit = "styles-module--exit--3a504";